<nz-tabset [nzTabPosition]="'top'" nzType="card" nzSize="small" [nzSelectedIndex]="selectedTabIndex" (nzSelectedIndexChange)="selectedTabIndex = $event">
	<nz-tab [nzTitle]="'Made by this agent'" class="m-0">
		<app-audit-timeline *ngIf="resultsByAgent" [audits]="resultsByAgent.records" [downloadHeading]="'Audit: Modifications made by: ' + agent.username" [downloadName]="'audit_modifications_made_by_' + agent.id"></app-audit-timeline>
	</nz-tab>
	<nz-tab [nzTitle]="'Made to this agent'" class="m-0">
		<app-audit-timeline *ngIf="resultsToAgent" [audits]="resultsToAgent.records" [downloadHeading]="'Audit: Modifications made to: ' + agent.username" [downloadName]="'audit_modifications_made_to_' + agent.id"></app-audit-timeline>
	</nz-tab>
</nz-tabset>
